import styled from 'styled-components';
import style from 'styles/style.css';

  
export const Button = styled.div`
   position: fixed; 
   width: 100%;
   left: 95%;
   bottom: 60px;
   height: 20px;
   font-size: 3rem;
   z-index: 1;
   cursor: pointer;
   color: #14b8a6;
   `